import { DismissSnackbar } from "../components/DismissSnackbar";

export const defaultSnackbarOptions = {
  variant: "info",
  anchorOrigin: {
    vertical: "bottom",
    horizontal: "left",
    autoHideDuration: 500,
  },
  action: (key) => <DismissSnackbar notificationKey={key} />,
};
